// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "resource/js/" + (chunkId === 750 ? "[request]" : chunkId) + "-legacy." + {"10":"6d33995d","354":"7bef5765","750":"94fe6ecc"}[chunkId] + ".js";
};